import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Houston.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Your Trusted Partner for Software Development in Houston</h2>
            <p>
              At TekRevol, we proudly stand as Houston's trusted partner for
              business software empowerment.
            </p>
            <p>
              With 5+ years of unmatchable experience and a team of skilled
              software developers in Houston, we have been instrumental in
              driving growth and efficiency for businesses of all sizes. Our
              commitment to innovation and customer-centric solutions makes us
              the go-to choice for companies seeking to harness the full
              potential of technology.
            </p>
            <p>
              Whether it's custom software development in Houston, app creation,
              or digital transformation, we empower businesses to streamline
              operations, elevate customer experiences, and outperform the
              competition. Venture into the journey of innovation with us, and
              see how we’re turning your dreams into reality.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
